import CONFIG from '@/constants/config.js';
export var layoutMixin = {

  data:()=>({
    from:null
  }),


  computed: {

    currentLocale () {
      return this.$i18n.locale.toUpperCase()
    },
    theme(){
      return (this.$vuetify.theme && this.$vuetify.theme.themes)?this.$vuetify.theme.themes[this.themeSchema]:{};
    },
    themeSchema(){
      return (this.$vuetify.theme && this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    bgHeight() {
      return this.$vuetify.breakpoint.height
    },
    bgWidth() {
      return this.$vuetify.breakpoint.width
    },
    isXlDevice(){
      return this.$vuetify.breakpoint.xl;
    },
    isLgDevice(){
      return this.$vuetify.breakpoint.lg;
    },
    isLgAndUpDevice(){
      return this.$vuetify.breakpoint.lgAndUp;
    },
    isMdDevice(){
      return this.$vuetify.breakpoint.md;
    },

    isMdAndDownDevice(){
      return this.$vuetify.breakpoint.mdAndDown;
  },
    isMdAndUpDevice(){
      return this.$vuetify.breakpoint.mdAndUp;
    },
    isSmDevice(){
      return this.$vuetify.breakpoint.sm;
    },
    isSmAndUpDevice(){
      return this.$vuetify.breakpoint.smAndUp;
    },
    isXsDevice(){
      return this.$vuetify.breakpoint.xs;
    },
    fontHeading(){
      return (this.isXsDevice || this.isSmDevice)?'display-1':'display-2';
    },
    fontTitle(){
      return (this.isXsDevice)?'display-2':'display-3b font-weight-medium';
    },
    fontHeadingStyle(){
      let fontSize=(this.isXsDevice || this.isSmDevice)?'':'2.75em!important;';
      return {"font-size":fontSize};
    },
    hinterlandEmail(){
      return CONFIG.EMAIL;
    }
  },
  methods: {
    hasWebPSupport() {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = function() { resolve(); };
        img.onerror = function() { reject(); };
        img.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
      })
    },
    addFixedBackgroundImageByClass(bgClassName){
      let body = document.querySelector('body');
      if(body){
        body.classList.add(bgClassName);
      }
    },
    removeFixedBackgroundImageByClass(bgClassName){
      let body = document.querySelector('body');
      if(body){
        body.classList.remove(bgClassName);
      }
    },
    makeBodyUnscrollable(val){
      let body = document.querySelector('body');
      let bgClassName="modal-open";
      let bgClassLockScreen="lock-screen";
      if(body){
        if(val){
          body.classList.add(bgClassName);
          body.classList.add(bgClassLockScreen);
        }else{
          body.classList.remove(bgClassName);
          body.classList.remove(bgClassLockScreen);
        }
      }
    },

    removeDoubleSlash(str){
      return (this._.isString(str))?str.replace(/\/\/+/g, '/'):str;
    },

    getRowStyle(borderColor){
      return (borderColor)?{"border-bottom":`5px solid ${borderColor}`}:'';
    },
    getGradientOpacity(opacity){
        return `to top right, rgba(3,3,3,${opacity}), rgba(3,3,3,${opacity})`;
    },
    goToHome(){
      if(this.$router){
         this.$router.push({ path: '/'});
      }else{
        window.location = CONFIG.URL;
      }
    },
    goToLogin() {
      if(this.$router){
        this.$router.push({ path: `/login`});
      }
    },
    goToRegister() {
      if(this.$router){
        this.$router.push({ path: `/register`});
      }
    },
    goBack(){
      if(this.$router){
        if(this.from=="" || this.from=="/"){
          this.goToHome();
        }else{
          this.$router.go(-1);
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
      next((vm) => {
          vm.from = (from)?from.fullPath:'';
      });
  }
}
